var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(15 18) rotate(-90) translate(-15 -18)",
    d: "m19.707 10.707c0.39052-0.39052 0.39052-1.0237 0-1.4142s-1.0237-0.39052-1.4142 0l-8 8c-0.39052 0.39052-0.39052 1.0237 0 1.4142l8 8c0.39052 0.39052 1.0237 0.39052 1.4142 0s0.39052-1.0237 0-1.4142l-7.2929-7.2929 7.2929-7.2929z",
    fill: "#373737",
    fillRule: "nonzero"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowDown.82c5018e.svg";
export { ForwardRef as ReactComponent };